/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
import i18n from 'i18n';
import moment from 'moment';
import { get } from 'lodash';
import { toast } from 'react-toastify';

import {
  UPLOAD_FILE_TYPE,
  validationCheckErrorType,
} from 'constants/index';
import {
  PICTURE_REGEX,
  VIDEO_REGEX,
} from 'constants/validationHelper';

const toastMessageLengthLimit = {
  SHORT: 30,
  MEDIUM: 80,
  LONG: 150,
};

const toastTimeClose = {
  SHORT: 1500,
  MEDIUM: 2000,
  LONG: 3000,
};

export const showToastError = (message) => {
  const mesLength = message?.length;
  // eslint-disable-next-line no-nested-ternary
  const closeTime = (mesLength < toastMessageLengthLimit.SHORT) ? toastTimeClose.SHORT
    : (mesLength < toastMessageLengthLimit.MEDIUM) ? toastTimeClose.MEDIUM : toastTimeClose.LONG;

  toast.error((message), { autoClose: closeTime });
};

export const validationErrorsArray = (errors = []) => {
  for (let i = 0; i < errors.length; i += 1) {
    showToastError(errors[i].msg);
  }
};

export const apiErrorHandler = (error, showToast = true) => {
  let message = 'default';

  if (error.response?.data?.errors?.length) {
    validationErrorsArray(error.response?.data?.errors);
  } else {
    if (error.response) {
      const errorData = error.response.data;
      if (errorData?.key === 'GIFT_STATUS_CANNOT_BE_UPDATED') {
        message = 'Không thể thay đổi trạng thái quà khi hết hạn hoặc hết hàng';
      } else {
        message = errorData.message;
      }
    } else if (error.request?._response) {
      message = error.request._response;
    } else if (error.message) {
      message = error.message;
    }

    if (showToast) {
      showToastError(message);
    }
  }
};

export const validationErrors = (errors = []) => {
  const newObj = {};

  for (let i = 0; i < errors.length; i += 1) {
    newObj[errors[i].param] = errors[i].msg;
  }

  return newObj;
};

export const convertCapitalString = (str) => {
  const mess = str.trim();
  return mess.charAt(0).toUpperCase() + mess.slice(1).toLowerCase();
};

export const showSuccessTrans = ({ type, name }) => {
  toast.success(convertCapitalString(i18n.t('success',
    {
      type: i18n.t(type),
      name: i18n.t(name),
    })));
};

export const showSuccess = (name) => {
  toast.success(convertCapitalString(name));
};

export const translateOptions = (name, options) => {
  const newOptions = [];

  for (let i = 0; i < options.length; i += 1) {
    newOptions.push({
      label: convertCapitalString(i18n.t(`${name}.${options[i].value}`)),
      value: options[i].value,
      ...options[i],
    });
  }

  return newOptions;
};

export const translateOptionsWithCondition = (
  variable, options, name, role, condition = 0, textStyle = 0,
) => {
  const newOptions = [];

  for (let i = 0; i < options.length; i += 1) {
    const option = {
      label: convertCapitalString(i18n.t(`${variable}.${options[i].value}`), textStyle),
      value: options[i].value,
      ...options[i],
    };

    switch (condition) {
      case 1:
        if (options[i][name] === role) option.isDisabled = true;
        break;

      default:
        if (options[i][name] !== role) option.isDisabled = true;
    }

    newOptions.push(option);
  }

  return newOptions;
};

export const getPlaceholderTrans = (placeholder) => {
  const { type, name } = placeholder;
  return convertCapitalString(i18n.t('global.placeholder',
    {
      type: i18n.t(type),
      name: i18n.t(name),
    }));
};

export const getRestoreOrRemoveTrans = (key, name) => convertCapitalString(i18n.t(key,
  {
    name: i18n.t(name),
  }));

export const getButtonNameTrans = (button) => {
  const { type, name } = button;

  return convertCapitalString(i18n.t('button_name',
    {
      type: i18n.t(type),
      name: i18n.t(name),
    }));
};

export const validationErrorHandler = (error) => {
  const { type, name, number } = error;
  return convertCapitalString(i18n.t(`validation.${type}`,
    {
      name: i18n.t(name),
      number: i18n.t(number),
    }));
};

export const checkHadError = (validation, key, type) => {
  if (type === validationCheckErrorType.ERR_ONLY) {
    return !!get(validation.errors, key, false);
  }

  if (type === validationCheckErrorType.TOUCHED_ONLY) {
    return !!get(validation.touched, key, false);
  }

  return !!(get(validation.touched, key, false) && get(validation.errors, key, false));
};

export const getParamsFormObject = (filters) => {
  const searchParams = new URLSearchParams();

  for (const key in filters) {
    const value = filters[key];

    if (value === '' || value === null || value === undefined) {
      delete filters[key];
    } else if (Array.isArray(value)) {
      value.forEach((v) => {
        searchParams.append(key, v);
      });
    } else {
      searchParams.set(key, value);
    }
  }

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const uploadFormatFile = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const checkFileType = (file, type) => {
  if (type === UPLOAD_FILE_TYPE.PICTURE_ONLY) {
    const allowedFile = new RegExp(PICTURE_REGEX);

    if (!allowedFile.test(file.type)) return { result: false, fileName: file.name };
  }

  if (type === UPLOAD_FILE_TYPE.VIDEO_ONLY) {
    const allowedFile = new RegExp(VIDEO_REGEX);

    if (!allowedFile.test(file.type)) return { result: false, fileName: file.name };
  }

  return { result: true };
};

export const uploadSingleFile = (file, type, fileSizeLimit) => {
  const currentFile = checkFileType(file, type);

  if (!currentFile.result) {
    if (type === UPLOAD_FILE_TYPE.PICTURE_ONLY) {
      toast.error('Hình ảnh định dạng JPG, JPEG, PNG');
    } else if (type === UPLOAD_FILE_TYPE.VIDEO_ONLY) {
      toast.error('Video định dạng MP4');
    }
    return null;
  }

  if (file.size < fileSizeLimit) {
    return Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: uploadFormatFile(file.size),
    });
  }

  if (type === UPLOAD_FILE_TYPE.PICTURE_ONLY) {
    toast.error(`Dung lượng ảnh không được vượt quá ${fileSizeLimit / 1024 / 1024}MB`);
  } else if (type === UPLOAD_FILE_TYPE.VIDEO_ONLY) {
    toast.error(`Dung lượng video không được vượt quá ${fileSizeLimit / 1024 / 1024}MB`);
  }

  return null;
};

export const removeSpacesWithTrim = (data) => {
  const newData = {};

  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'string' && value !== '') {
      newData[key] = value.trim();
    } else {
      newData[key] = value;
    }
  }

  return newData;
};

export const getUserForFirstName = (user) => {
  const fullName = `${user?.firstName || ''} ${user?.lastName || ''} ${user?.middleName || ''}`;

  return fullName.trim();
};

export const convertArrayToOptions = (arr = []) => {
  const newOptions = [];

  if (!arr) return '';

  if (typeof arr === 'object' && !Array.isArray(arr)) {
    return {
      label: arr?.name || getUserForFirstName(arr) || arr.username || arr?.label || arr?.title,
      value: arr?._id || arr?.value || arr?.id,
      avatar: arr.image || arr.avatar,
    };
  }

  for (let i = 0; i < arr.length; i += 1) {
    if ((arr[i].name !== undefined
      || arr[i].firstName !== undefined
      || arr[i].username) !== undefined && !arr[i].deletedAt) {
      newOptions.push({
        label: arr[i].name
          || getUserForFirstName(arr[i])
          || arr[i].username
          || arr?.label
          || arr[i].title,
        value: arr[i]._id || arr?.value || arr[i].id,
        avatar: arr[i].image || arr[i].avatar,
        reason: arr[i].reason || arr[i].reason,
        suggestion: arr[i].suggestion || arr[i].suggestion,
        type: arr[i].type || arr[i].type,
      });
    }
  }

  return newOptions;
};

export const selectInvalid = () => ({ control: (provided) => ({ ...provided, border: '1px solid #f46a6a !important' }) });

export const checkPermission = (role, permission = '') => {
  if (role?.isRoot || role?.permissions?.includes(permission)) {
    return true;
  }

  return false;
};

export const getUserFullName = (user) => {
  const fullName = `${user?.lastName || ''} ${user?.middleName || ''} ${user?.firstName || ''} `;

  return fullName.trim();
};

export const convertIsoDateToString = (date, format = 'DD/MM/YYYY') => {
  if (date === '' || date === undefined || date === null) return '';

  return moment(new Date(date)).format(format);
};

export const sortArrayOptions = (a, b) => {
  if (a.firstName) {
    return 1 * a.firstName?.localeCompare(b?.firstName, 'es', { sensitivity: 'base' });
  }
  return 1 * a.label?.localeCompare(b?.label, 'es', { sensitivity: 'base' });
};

export const getPathNameImage = (img = '') => {
  const pathName = img.split('/')[img.split('/').length - 1];

  return pathName;
};

export const uploadLogoFormatFile = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const guidGeneratorID = () => {
  // eslint-disable-next-line no-bitwise
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
};

export const formatPhoneNumberToServer = (phoneNumber) => {
  let phone = '';
  if (phoneNumber) {
    phone = phoneNumber.replace('0', '+84');
  }
  return phone;
};

export const parseCurrency = (currency = '', notRound) => {
  let newCurrency = 0;

  const currencyLength = currency.length;

  newCurrency = parseFloat(currencyLength > 3 ? (currency).split('.').join('').replace(',', '.') : currency, 10);

  return notRound ? newCurrency : Math.round(newCurrency);
};

export const invalidNumberArea = (number, min = 0, max = 0) => number < min || number > max;

export const unparseCurrency = (value = 0) => {
  const [integerPart, fractionalPart] = String(value).split('.');

  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  const formattedValue = fractionalPart !== undefined ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

  return formattedValue;
};

export const checkFirstNumber = (value) => {
  if (typeof value === 'string' && !value) {
    value = '';
  } else if (value[0] === '0' || value[0] === 0) {
    const nextChar = value[1];
    const isDecimalInput = nextChar === '.' || nextChar === ',';

    if (isDecimalInput) {
      return value;
    }

    if (value.length === 1) {
      value = 0;
    } else {
      value = value.substring(1);
    }
  }

  return value;
};

export const cleanVariantData = (draffVariants) => {
  const variants = draffVariants.map((item) => {
    const variant = {};

    variant.name = item.name;

    variant.values = item.values.filter(
      (v) => v.variantName,
    ).map((v) => v.variantName);

    variant.images = item.values.filter(
      (v) => v.variantName,
    ).map((v) => v.image && v.image._id).filter((i) => i);

    if (variant.images.length === 0) delete variant.images;

    return variant;
  });

  return variants;
};

export const getDatesRank = (start, stop) => {
  const listDate = [];
  let currentDate = new Date(start);
  const stopDate = new Date(stop);

  while (currentDate <= stopDate) {
    listDate.push(moment(currentDate));
    currentDate = moment(currentDate).add(1, 'days');
  }

  return listDate;
};

export const onCheckSameDay = (d1, d2) => d1.getFullYear() === d2.getFullYear()
  && d1.getMonth() === d2.getMonth()
  && d1.getDate() === d2.getDate();

export const getPathname = (url) => url.split('/').slice(3).join('/');

export const currencyToNumber = (currencyString) => {
  // Remove currency symbols, minus and commas
  const cleanedString = currencyString.replace(/[^\d]/g, '');

  const result = parseFloat(cleanedString);

  if (Number.isNaN(result)) {
    return null;
  }

  return result;
};

export const areDatesConsecutive = (dateList) => {
  for (let i = 0; i < dateList.length - 1; i += 1) {
    const currentEnd = new Date(dateList[i].endAt);
    const nextStart = new Date(dateList[i + 1].startAt);

    if (currentEnd > nextStart) {
      return false;
    }
  }
  return true;
};

export const bookingDate = (detailMyBooking) => {
  const newStartDate = new Date(detailMyBooking.startedAt);
  const newEndDate = new Date(detailMyBooking.endedAt);

  const differenceMilliseconds = Math.abs(newEndDate - newStartDate);
  const diffInDays = Math.floor(differenceMilliseconds / (1000 * 60 * 60 * 24));

  return diffInDays;
};

export const getMessageError = (error) => {
  const message = 'Có lỗi xảy ra';

  let errorMessage = message;

  if (error.response?.data?.message) {
    errorMessage = error.response?.data?.message;
  } else if (error?.message) {
    errorMessage = error.message;
  } else {
    errorMessage = typeof error === 'string' ? error : message;
  }

  return errorMessage || message;
};

export const handleError = (error, mes, t) => {
  const result = mes || getMessageError(error);
  const resultMessage = t ? t(result) : result;
  toast.error(resultMessage);
  return resultMessage;
};

export const getFormErrors = (error) => {
  if (error.response?.data?.errors) {
    return error.response?.data.errors ?? [];
  }

  return [];
};

export const setFormErrors = (
  errors,
  form,
) => {
  errors.forEach((e) => {
    form.setFieldError(e.param, e.msg);
  });
};

export const setFormErrorsOrHandleError = (
  error,
  form,
  mes,
) => {
  const errors = getFormErrors(error);
  if (errors.length) {
    setFormErrors(errors, form);
  } else {
    handleError(error, mes);
  }
};

export const SIZE_MB = 5;
export const FILE_MAX_SIZE = 1024 * 1024 * SIZE_MB; // 5MB
export const FILE_ALLOW_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.svg'];

export const getFileExtension = (fileName) => {
  const parts = fileName.split('.');
  return parts[parts.length - 1];
};

export const validateImageFile = (file) => {
  if (!file) return [null, null];

  const fileExtension = getFileExtension(file.name);

  if (file.size > FILE_MAX_SIZE) {
    return [`Kích thước file không được vượt quá ${SIZE_MB}MB`, file];
  }

  if (
    !['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'].includes(file.type)
    || !FILE_ALLOW_EXTENSIONS.includes(`.${fileExtension.toLowerCase()}`)
  ) {
    return ['Định dạng file không hợp lệ', file];
  }

  return [null, file];
};

export const removeDiacritics = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');

export const filterEmptyObject = (obj) => (obj ? Object
  .fromEntries(
    Object
      .entries(obj)
      .filter(([, value]) =>
        value !== '',
        // && value !== null
        // && value !== undefined,
      ),
  ) : null);

export const filterAllValueObject = (obj) => (obj ? Object
  .fromEntries(
    Object
      .entries(obj)
      .filter(([, value]) =>
        value !== '' && value !== 'ALL',
      ),
  ) : null);

export const getRatingText = (star) => {
  switch (star) {
    case 5:
      return 'Tuyệt vời';
    case 4:
      return 'Rất tốt';
    case 3:
      return 'Tốt';
    case 2:
      return 'Trung bình';
    case 1:
      return 'Kém';
    default:
      return 'N/A';
  }
};

export const getRatingAverageText = (rating) => {
  if (rating >= 5) return 'Tuyệt vời';
  if (rating >= 4) return 'Rất tốt';
  if (rating >= 3) return 'Tốt';
  if (rating >= 2) return 'Trung bình';
  return 'Kém';
};

export const getTotalReviewCount = (location) => (
  (location.total1starReviews ?? 0)
  + (location.total2starReviews ?? 0)
  + (location.total3starReviews ?? 0)
  + (location.total4starReviews ?? 0)
  + (location.total5starReviews ?? 0)
);

export const isMongoId = (id) => /^[0-9a-fA-F]{24}$/.test(id);

export const onKeyDownIntegerOnly = (e) => {
  if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
    e.preventDefault();
  }
};

export const getSanitizedInteger = (value, min = 0, max = 999, defaultValue = '') => {
  if (value === '') return defaultValue;
  return Math.min(max, Math.max(min, parseInt(value, 10) || 0));
};

export const getPlaceIdFromReview = (reviewItem) => {
  const place = reviewItem?.place;
  const bookingPlace = reviewItem?.userBooking?.place;

  if (typeof place === 'string') return place;
  if (typeof bookingPlace === 'string') return bookingPlace;

  return (
    reviewItem?.place?._id
    || reviewItem?.place?.id
    || reviewItem?.place?.placeId
    || reviewItem?.userBooking?.place?._id
    || reviewItem?.userBooking?.place?.id
    || reviewItem?.userBooking?.place?.placeId
    || reviewItem?.userBooking?.placeId
    || reviewItem?.placeId
    || ''
  );
};
